import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { map } from 'rxjs';
import { LassiLayersList } from './layers';
import { PROFILE_QUERY_PARAM_KEY } from './map';

export const presetGuard: CanActivateFn = (route, state) => {
  const profile = route.queryParams[PROFILE_QUERY_PARAM_KEY];

  if (profile) {
    return true;
  }

  const layerList$ = inject(LassiLayersList);
  const router = inject(Router);

  return layerList$.pipe(
    map((layerList) => layerList.presets[0]),
    map((preset) => preset?.name),
    map((defaultProfile) => {
      if (!defaultProfile) {
        return true; // No presets available, allow access
      }

      const url = new URL(state.url, window.location.origin);
      url.searchParams.set(PROFILE_QUERY_PARAM_KEY, defaultProfile);

      const urlTree = router.parseUrl(url.pathname + url.search);

      return new RedirectCommand(urlTree, {
        replaceUrl: true,
      });
    }),
  );
};
